export class Accordion {
  recordType: string;
  title: string;
  parentTitle: string;
  articleText: string;
  children: Accordion[];
}
